// extracted by mini-css-extract-plugin
export default {"calendar":"BaseCalendar_calendar__ZXet2"};